export default __webpack_public_path__ + "static/media/512.b5d167bb.png";